import { IconButton, Typography, withStyles } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import InputAdornment from '@material-ui/core/InputAdornment'
import RefreshIcon from '@material-ui/icons/Refresh'
import { Snackbar } from 'elentari'
import * as R from 'ramda'
import React, { useState } from 'react'
import { Field } from 'react-final-form'
import { OnChange } from 'react-final-form-listeners'
import { useParams } from 'react-router-dom'
import {
  CustomDateTimePicker,
  CustomSelect,
  CustomTextField
} from '../../../components/CustomDisabledFields'
import CustomFileViewer from '../../../components/CustomFileViewer'
import DropzoneField from '../../../components/DropzoneField'
import NumberFormatCustom from '../../../components/NumberFormatCustom'
import ObservacaoField from '../../../components/ObservacaoField'
import Select from '../../../components/Select'
import UploadField from '../../../components/UploadField'
import { parseCep, parseCpf, parsePlaca, parseTelefone } from '../../../utils/Parse'
import MercadoriaAutocomplete from '../../Mercadorias/MercadoriaAutocomplete'
import { estadosOptions } from '../../Municipio/estados'
import MunicipioAutocomplete from '../../Municipio/MunicipioAutocomplete'
import GerenciadoraField from '../Fields/GerenciadoraField'
import { tarefaDadosMotoristaRepository } from '../tarefaRepository'
import EntregasFields from './EntregasFields'

const styles = theme => ({
  marginTop: {
    marginTop: theme.spacing(5)
  }
})

const MonitoramentoEmbarcadorForm = ({
  form,
  values,
  cannotUpdate,
  showError
}) => {
  const handleFileChange = (filePath, file) => {
    form.change(file, filePath)
  }
  const [motoristaFormState, setMotoristaFormState] = useState({
    state: '',
    message: ''
  })
  const [alreadyFetched, setAlreadyFetched] = useState(false)
  const [fetching, setFetching] = useState(false)
  const { id } = useParams()
  const isNew = /new/.test(id)

  const handleChangeCpf = async () => {
    const cpfFormated = values.cpfMotorista
    const cpf = cpfFormated && cpfFormated.replace(/[^\d]/g, '')

    if (cpf && cpf.length === 11 && !alreadyFetched && isNew) {
      setAlreadyFetched(true)
      setFetching(true)
      setMotoristaFormState({
        state: 'fetching',
        message: 'Buscando motorista'
      })

      const response = await tarefaDadosMotoristaRepository.dadosMotorista(cpf)
      if (response.ok) {
        const motorista = response.data
        form.batch(() => {
          form.change('nomeMotorista', motorista.nomeMotorista)
          form.change('cpf', motorista.cpfMotorista)
          form.change('telefoneMotorista', motorista.telefoneMotorista)
          form.change('cnh', motorista.cnh)
          form.change('placaCavalo', motorista.placaCavalo)
          form.change('crlv', motorista.crlv)
          form.change('placa1', motorista.placa1)
          form.change('placa2', motorista.placa2)
          form.change('placa3', motorista.placa3)
          form.change('tecnologia', motorista.tecnologia)
          form.change('marcaTecnologia', motorista.marcaTecnologia)
          form.change('nomeResponsavelFrota', motorista.nomeResponsavelFrota)
          form.change(
            'telefoneResponsavelFrota',
            motorista.telefoneResponsavelFrota
          )
        })
        setMotoristaFormState({
          state: 'success',
          message: 'Motorista encontrado com sucesso!'
        })
      } else {
        setMotoristaFormState({
          state: 'error',
          message: R.pathOr(
            'Motorista não cadastrado na Central de Cadastros',
            ['data', 'error', 'message'],
            response
          )
        })
      }
      setFetching(false)
    } else {
      setAlreadyFetched(false)
    }
  }
  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Informações da Viagem
        </Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <Field
          fullWidth
          name="ordemCarregamento"
          label="OC/SD"
          disabled={cannotUpdate}
          component={CustomTextField}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field
          fullWidth
          component={MercadoriaAutocomplete}
          label="Mercadoria"
          name="mercadoriaId"
          needDescription
          showError={showError}
          disabled={cannotUpdate || !isNew}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Field
          fullWidth
          component={CustomTextField}
          InputProps={{
            inputComponent: NumberFormatCustom
          }}
          label="Valor Carga"
          name="valorCarga"
          showError={showError}
          disabled={cannotUpdate || !isNew}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field
          fullWidth
          name="tomador"
          label="Cliente/Tomador"
          disabled={cannotUpdate}
          component={CustomTextField}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Field
          fullWidth
          name="previsaoCarregamento"
          label="Previsão de Carregamento"
          component={CustomDateTimePicker}
          disabled={cannotUpdate}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Field
          fullWidth
          name="previsaoEntrega"
          label="Previsão de Entrega"
          component={CustomDateTimePicker}
          disabled={cannotUpdate}
        />
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={2}>
            <Field
              fullWidth
              hideEmpty
              component={Select}
              options={estadosOptions}
              label="Estado Origem"
              name="estadoOrigem"
              showError={showError}
              disabled={cannotUpdate}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Field
              fullWidth
              provinciaId={values.estadoOrigem}
              component={MunicipioAutocomplete}
              label="Cidade Origem"
              name="cidadeOrigem"
              showError={showError}
              disabled={cannotUpdate}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Field
              fullWidth
              component={CustomTextField}
              format={parseCep}
              label="CEP Origem"
              name="cepOrigem"
              showError={showError}
              disabled={cannotUpdate}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Field
              fullWidth
              name="logradouroOrigem"
              label="Logradouro Origem"
              disabled={cannotUpdate}
              component={CustomTextField}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Field
              fullWidth
              name="numeroOrigem"
              label="Número Origem"
              disabled={cannotUpdate}
              component={CustomTextField}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Field
              fullWidth
              name="complementoOrigem"
              label="Descrição Extra Origem"
              disabled={cannotUpdate}
              component={CustomTextField}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Field
              fullWidth
              hideEmpty
              component={Select}
              options={estadosOptions}
              label="Estado Destino"
              name="estadoDestino"
              showError={showError}
              disabled={cannotUpdate}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Field
              fullWidth
              provinciaId={values.estadoDestino}
              component={MunicipioAutocomplete}
              label="Cidade Destino"
              name="cidadeDestino"
              showError={showError}
              disabled={cannotUpdate}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Field
              fullWidth
              component={CustomTextField}
              format={parseCep}
              label="CEP Destino"
              name="cepDestino"
              showError={showError}
              disabled={cannotUpdate}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Field
              fullWidth
              name="logradouroDestino"
              label="Logradouro Destino"
              disabled={cannotUpdate}
              component={CustomTextField}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Field
              fullWidth
              name="numeroDestino"
              label="Número Destino"
              disabled={cannotUpdate}
              component={CustomTextField}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Field
              fullWidth
              name="complementoDestino"
              label="Descrição Extra Destino"
              disabled={cannotUpdate}
              component={CustomTextField}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <EntregasFields
          entregas={values.entregas}
          showError={showError}
          disabled={cannotUpdate}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Motorista
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <Field
              fullWidth
              component={CustomTextField}
              format={parseCpf}
              label="CPF"
              InputLabelProps={{ shrink: !!values.cpfMotorista }}
              name="cpfMotorista"
              disabled={fetching || cannotUpdate || !isNew}
              showError={showError}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      disabled={cannotUpdate}
                      onClick={handleChangeCpf}
                    >
                      <RefreshIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            <OnChange name="cpfMotorista">{handleChangeCpf}</OnChange>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              fullWidth
              component={CustomTextField}
              label="Nome"
              name="nomeMotorista"
              disabled={fetching || cannotUpdate}
              showError={showError}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Field
              fullWidth
              component={CustomTextField}
              label="Telefone"
              parse={parseTelefone}
              name="telefoneMotorista"
              disabled={fetching || cannotUpdate}
              showError={showError}
            />
          </Grid>
          {isNew ? (
            <Grid item xs={12} lg={3}>
              <Field
                accept=".jpg,.jpeg,.png,.pdf"
                label="CNH"
                name="cnh"
                component={UploadField}
                onFileChange={filePath => handleFileChange(filePath, 'cnh')}
                showError={showError}
              />
            </Grid>
          ) : (
            <>
              {!cannotUpdate && (
                <Grid item xs={12} lg={3}>
                  <Field
                    solicitacaoId={values.id}
                    accept=".jpg,.jpeg,.png,.pdf"
                    component={DropzoneField}
                    label="CNH"
                    name="cnh"
                    onFileChange={filePath => handleFileChange(filePath, 'cnh')}
                  />
                </Grid>
              )}
              <Grid item xs={12} lg={3}>
                <CustomFileViewer
                  newTab
                  label="CNH"
                  filePath={values.cnh}
                  fileType="pdf"
                />
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Veiculos
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <Field
              fullWidth
              component={CustomTextField}
              label="Placa Cavalo"
              parse={parsePlaca}
              name="placaCavalo"
              disabled={cannotUpdate}
              showError={showError}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Field
              fullWidth
              component={CustomTextField}
              label="Placa 1"
              parse={parsePlaca}
              name="placa1"
              disabled={cannotUpdate}
              showError={showError}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Field
              fullWidth
              component={CustomTextField}
              label="Placa 2"
              parse={parsePlaca}
              name="placa2"
              disabled={cannotUpdate}
              showError={showError}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Field
              fullWidth
              component={CustomTextField}
              label="Placa 3"
              parse={parsePlaca}
              name="placa3"
              disabled={cannotUpdate}
              showError={showError}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Grid container spacing={1}>
              {isNew ? (
                <Grid item xs={12}>
                  <Field
                    accept=".jpg,.jpeg,.png,.pdf"
                    label="CRLV Cavalo"
                    name="crlv"
                    component={UploadField}
                    onFileChange={filePath =>
                      handleFileChange(filePath, 'crlv')
                    }
                    showError={showError}
                  />
                </Grid>
              ) : (
                <>
                  {!cannotUpdate && (
                    <Grid item xs={12}>
                      <Field
                        solicitacaoId={values.id}
                        accept=".jpg,.jpeg,.png,.pdf"
                        component={DropzoneField}
                        label="CRLV Cavalo"
                        name="crlv"
                        onFileChange={filePath =>
                          handleFileChange(filePath, 'crlv')
                        }
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} rowSpacing={3}>
                    <CustomFileViewer
                      newTab
                      label="CRLV Cavalo"
                      filePath={values.crlv}
                      fileType="pdf"
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} md={3}>
            <Grid container spacing={1}>
              {isNew ? (
                <Grid item xs={12}>
                  <Field
                    accept=".jpg,.jpeg,.png,.pdf"
                    label="CRLV Placa 1"
                    name="crlvPlaca1"
                    component={UploadField}
                    onFileChange={filePath =>
                      handleFileChange(filePath, 'crlvPlaca1')
                    }
                    showError={showError}
                  />
                </Grid>
              ) : (
                <>
                  {!cannotUpdate && (
                    <Grid item xs={12}>
                      <Field
                        solicitacaoId={values.id}
                        accept=".jpg,.jpeg,.png,.pdf"
                        component={DropzoneField}
                        label="CRLV Placa 1"
                        name="crlvPlaca1"
                        onFileChange={filePath =>
                          handleFileChange(filePath, 'crlvPlaca1')
                        }
                      />
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <CustomFileViewer
                      newTab
                      label="CRLV Placa 1"
                      filePath={values.crlvPlaca1}
                      fileType="pdf"
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>

          <Grid item xs={12} md={3}>
            <Grid container spacing={1}>
              {isNew ? (
                <Grid item xs={12}>
                  <Field
                    accept=".jpg,.jpeg,.png,.pdf"
                    label="CRLV Placa 2"
                    name="crlvPlaca2"
                    component={UploadField}
                    onFileChange={filePath =>
                      handleFileChange(filePath, 'crlvPlaca2')
                    }
                    showError={showError}
                  />
                </Grid>
              ) : (
                <>
                  {!cannotUpdate && (
                    <Grid item xs={12}>
                      <Field
                        solicitacaoId={values.id}
                        accept=".jpg,.jpeg,.png,.pdf"
                        component={DropzoneField}
                        label="CRLV Placa 2"
                        name="crlvPlaca2"
                        onFileChange={filePath =>
                          handleFileChange(filePath, 'crlvPlaca2')
                        }
                      />
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <CustomFileViewer
                      newTab
                      label="CRLV Placa 2"
                      filePath={values.crlvPlaca2}
                      fileType="pdf"
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>

          <Grid item xs={12} md={3}>
            <Grid container spacing={1}>
              {isNew ? (
                <Grid item xs={12}>
                  <Field
                    accept=".jpg,.jpeg,.png,.pdf"
                    label="CRLV Placa 3"
                    name="crlvPlaca3"
                    component={UploadField}
                    onFileChange={filePath =>
                      handleFileChange(filePath, 'crlvPlaca3')
                    }
                    showError={showError}
                  />
                </Grid>
              ) : (
                <>
                  {!cannotUpdate && (
                    <Grid item xs={12}>
                      <Field
                        solicitacaoId={values.id}
                        accept=".jpg,.jpeg,.png,.pdf"
                        component={DropzoneField}
                        label="CRLV Placa 3"
                        name="crlvPlaca3"
                        onFileChange={filePath =>
                          handleFileChange(filePath, 'crlvPlaca3')
                        }
                      />
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <CustomFileViewer
                      newTab
                      label="CRLV Placa 3"
                      filePath={values.crlvPlaca3}
                      fileType="pdf"
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>

          <Grid item xs={12} md={3}>
            <Field
              fullWidth
              hideEmpty
              component={CustomSelect}
              options={[
                { label: 'Telemonitoramento', value: 'TELEMONITORAMENTO' },
                { label: 'Localizador', value: 'LOCALIZADOR' },
                { label: 'Rastreador', value: 'RASTREADOR' }
              ]}
              label="Tipo de tecnologia"
              name="tecnologia"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Field
              fullWidth
              name="marcaTecnologia"
              label="Marca/Modelo"
              disabled={cannotUpdate}
              component={CustomTextField}
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <Field
              fullWidth
              name="loginRastreador"
              label="Login"
              disabled={
                cannotUpdate || values.tecnologia === 'TELEMONITORAMENTO'
              }
              component={CustomTextField}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Field
              fullWidth
              name="senhaRastreador"
              label="Senha"
              disabled={
                cannotUpdate || values.tecnologia === 'TELEMONITORAMENTO'
              }
              component={CustomTextField}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Field
              fullWidth
              name="terminal"
              label="ID/Terminal"
              disabled={cannotUpdate || values.tecnologia !== 'RASTREADOR'}
              component={CustomTextField}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={3}>
            <Field
              hideEmpty
              component={CustomSelect}
              options={[
                { label: 'Não', value: false },
                { label: 'Sim', value: true }
              ]}
              label="Isca"
              name="possuiIsca"
            />
          </Grid>
          {values.possuiIsca && (
            <>
              <Grid item xs={12} sm={3}>
                <Field
                  fullWidth
                  name="imei"
                  label="Número/IMEI"
                  disabled={cannotUpdate}
                  component={CustomTextField}
                />
              </Grid>
              {isNew ? (
                <Grid item xs={12} lg={3}>
                  <Field
                    accept=".jpg,.jpeg,.png"
                    component={UploadField}
                    label="Foto da Isca"
                    name="isca"
                    onFileChange={filePath =>
                      handleFileChange(filePath, 'isca')
                    }
                    showError={showError}
                  />
                </Grid>
              ) : (
                <>
                  <Grid item xs={12} lg={3}>
                    <Field
                      solicitacaoId={values.id}
                      accept=".jpg,.jpeg,.png"
                      component={DropzoneField}
                      label="Foto da Isca"
                      name="isca"
                      onFileChange={filePath =>
                        handleFileChange(filePath, 'isca')
                      }
                      showError={showError}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <CustomFileViewer
                      newTab
                      label="Foto da Isca"
                      filePath={values.isca}
                      fileType="pdf"
                    />
                  </Grid>
                </>
              )}
            </>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Responsável pela frota
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Field
              fullWidth
              component={CustomTextField}
              label="Nome"
              name="nomeResponsavelFrota"
              disabled={cannotUpdate}
              showError={showError}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              fullWidth
              component={CustomTextField}
              parse={parseTelefone}
              label="Telefone"
              name="telefoneResponsavelFrota"
              disabled={cannotUpdate}
              showError={showError}
            />
          </Grid>
        </Grid>
      </Grid>
      {!isNew && (
        <>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Monitoramento
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <GerenciadoraField disabled />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              fullWidth
              disabled
              name="identificadorGerenciadora"
              label="Código Identificador"
              component={CustomTextField}
            />
          </Grid>
        </>
      )}
      <ObservacaoField
        value={values.observacao}
        title="Observações"
        placeholder="Escreva aqui observações sobre o monitoramento"
        name="novaObservacao"
        disabled={cannotUpdate}
      />
      <Snackbar
        message={motoristaFormState.message}
        onClose={() =>
          setMotoristaFormState({ ...motoristaFormState, message: '' })
        }
      />
    </Grid>
  )
}

export default withStyles(styles)(MonitoramentoEmbarcadorForm)
